import { Box, Typography } from '@mui/material';
import useAppVersion from '../../../util/hooks/useAppVersion';

/**
 * VersionDisplay Component
 * Displays backend and frontend version information.
 * Rendered inline inside the sidebar footer, so it never overlaps the navigation items.
 */
const VersionDisplay = () => {
    const { backendVersion, frontendVersion, loading } = useAppVersion();

    if (loading) {
        return null; // Don't show anything while loading
    }

    return (
        <Box sx={{ textAlign: 'left' }}>
            <Typography
                variant="caption"
                component="div"
                sx={{
                    display: 'block',
                    color: 'rgba(255, 255, 255, 0.8)',
                    fontSize: '0.7rem',
                    lineHeight: 1.4,
                    fontFamily: 'inherit',
                }}
            >
                BE: {backendVersion} &nbsp;|&nbsp; FE: {frontendVersion}
            </Typography>
        </Box>
    );
};

export default VersionDisplay;
